<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <date-format-select
        @changeDateFormatData="changeDateFormatData($event.dateFormatId)"
      />
      <search-channel-select
        v-model="tableParams.channelId"
        :channelType="100"
      />
      <search-channel-slot-select v-model="tableParams.slotId" />
      <search-dsp-select v-model="tableParams.dspId" :dspType="100" />
      <search-dsp-slot-select
        v-model="tableParams.dspSlotId"
        :dsp-id="tableParams.dspId"
      />
      <el-select
        v-model="tableParams.appType"
        clearable
        placeholder="请选择应用类型"
      >
        <el-option
          v-for="item in appTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="
            downExcel('/webCoordDefine/list/xlsx', '坐标宏数据', tableParams)
          "
          type="warning"
          size="small"
        >
          下载
        </el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-if="tableParams.showType > 0"
          prop="timeHour"
          :label="
            tableParams.showType === 2 || tableParams.showType === 4
              ? '日期'
              : '时间'
          "
          fixed
          sortable
          align="center"
        />
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <span>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template v-slot="scope">
            <router-link
              :to="{
                path: '/heatmap',
                query: {
                  slotId: scope.row['slotId'],
                  dspSlotId: scope.row['dspSlotId'],
                  date: this.search.endTime,
                  slotName:scope.row['slotName']
                },
              }"
              target="_blank"
            >
              <el-button type="primary" size="mini">热力图</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
  </div>
</template>

<script>
import { appTypeList } from "@/const/app-type";
import TableColumn from "@/components/TableColumn";
import DateFormatSelect from "@/components/DateFormatSelect";
import BaseDatePicker from "@/components/BaseDatePicker";
import SearchChannelSelect from "@/components/SearchChannelSelect";
import SearchChannelSlotSelect from "@/components/SearchChannelSlotSelect";
import SearchDspSelect from "@/components/SearchDspSelect";
import SearchDspSlotSelect from "@/components/SearchDspSlotSelect";
import initTableMixin from "@/mixins/initTable";
import { downExcelMixin } from "@/mixins/downExcel";

export default {
  name: "managerDspCoordinate",
  components: {
    TableColumn,
    DateFormatSelect,
    BaseDatePicker,
    SearchChannelSelect,
    SearchChannelSlotSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      appTypeList,
      columns: [
        {
          field: "channelName",
          title: "渠道名称",
        },
        {
          field: "dspName",
          title: "DSP名称",
        },
        {
          field: "slotId",
          title: "广告位编号",
        },
        {
          field: "slotName",
          title: "渠道广告名称",
        },
        {
          field: "dspSlotName",
          title: "DSP广告位名称",
        },
        {
          field: "sw",
          title: "广告实际宽度",
        },
        {
          field: "sh",
          title: "广告实际高度",
        },
        {
          field: "downX",
          title: "DOWN-X",
        },
        {
          field: "downY",
          title: "DOWN-Y",
        },
        {
          field: "upX",
          title: "UP-X",
        },
        {
          field: "upY",
          title: "UP-Y",
        },
        {
          field: "ts",
          title: "时间戳毫秒",
        },
        {
          field: "tss",
          title: "时间戳秒",
        },
      ],
      dateFormatId: 0,
      search: {
        startTime: "",
        endTime: "",
      },
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.tableParams.showType = 0;
      this.toQuery();
    });
  },
  methods: {
    beforeInit() {
      this.tableUrl = "/webCoordDefine/list";
      return true;
    },
    changeDate(date) {
      this.search.startTime = date.startTime;
      this.search.endTime = date.endTime;
    },
    toQuery() {
      this.tableParams.startTime = this.search.startTime + "00";
      this.tableParams.endTime = this.search.endTime + "23";
      this.init();
    },
    changeDateFormatData(dateFormatId) {
      if (dateFormatId === 1) {
        // 日
        this.tableParams.showType = 3;
      } else if (dateFormatId === 2) {
        // 时
        this.tableParams.showType = 2;
      } else if (dateFormatId === 3) {
        // 月
        this.tableParams.showType = 4;
      } else {
        // 正常
        this.tableParams.showType = 0;
      }
      this.toQuery();
    },
  },
};
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
